<template>
    <div>
        <h4 class="title__name">Live In-Play</h4>
        <v-list class="py-0 borders">
            <v-list-tile v-for="(item,index) in sports" avatar :key="index" @click="setSport(item.sport)" :class="{'selectedSport': selectedSport===item.sport ,'sport-btn px-0':(true)}">
                <v-list-tile-avatar size="40px" class="px-0">
                    <img :src="getSportIconPath(item.sport)" :alt="item.sport">
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title v-html="item.sport"></v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
    </div>
</template>
<script>
    import { HubConnection } from "@aspnet/signalr";
    import BetOptions from './BetOptions.vue';
    import SportsApi from '../api/sportFixtures';
    import * as CONFIG from "../config";

    export default {
        name: "Sports",
        components: {
            BetOptions
        },
        props: {
            connection: HubConnection,
        },
        data() {
            return {
                sports: [],
                selectedSport: null,
                right: null
            }
        },
        mounted() {
            SportsApi.getSportFixtures()
                .then(data => {
                    // this.sports = data.responseObject;
                    this.selectedSport = data && data.responseObject && data.responseObject[0] && data.responseObject[0].sport;
                    this.$emit('setSport', this.selectedSport);
                    for (var i = 0; i < data.responseObject.length; i++) {
                        if (data.responseObject[i].sport === CONFIG.AVAILABLE_SPORTS_MOZ.Football || data.responseObject[i].sport === CONFIG.AVAILABLE_SPORTS_MOZ.Tennis) {
                            this.sports.push(data.responseObject[i]);
                        }
                    }
                })
            if (this.connection) {
                this.connection.on("sportUpdate", (value) => {
                    this.updateSport(JSON.parse(value));
                });
            }
        },
        methods: {
            sportContains(image) {
                return image.indexOf(image) >= -1
            },
            getSportIconPath(sportName) {
                if (sportName) {
                    if (this.sportContains(sportName)) {
                        const svgName = sportName.replace(/\s/g, '-').toLowerCase();
                        return require(`../assets/img/icons/${svgName}.svg`);
                    }
                }
            },
            setSport(sport) {
                this.selectedSport = sport;
                this.$emit('setSport', sport);

            },
            updateSport(updatedSport) {
                if (this.sports !== updatedSport) {
                    this.sports = this.mergeSport(this.sports, updatedSport);
                }
            },
            mergeSport(api, signalR) {
                let temp = api.map(s => s.sport);
                for (let item in signalR) {
                    if (signalR[item].Sport === CONFIG.AVAILABLE_SPORTS_MOZ.Football || signalR[item].Sport === CONFIG.AVAILABLE_SPORTS_MOZ.Tennis) {
                        let value = signalR[item].Sport;
                        if (temp.indexOf(value) === -1)
                            api.push({ sport: value })
                    }
                }
                return api
            }
        },
    }
</script>
<style>
    .selectedSport {
        background-color: #643e94 !important;
    }

        .selectedSport .v-list__tile__action {
            background-color: #2b2b2b !important;
        }

        .selectedSport .v-list__tile__avatar {
            background-color: #2b2b2b;
        }

    aside.v-navigation-drawer.v-navigation-drawer--open.theme--dark {
        background-color: #2b2b2b !important;
    }

    .theme--dark.v-expansion-panel .v-expansion-panel__container {
        border-top: 1px solid #fff !important;
    }

        .theme--dark.v-expansion-panel .v-expansion-panel__container:nth-child(1) {
            border-top: 1px solid transparent !important;
        }

    .betOptions {
        padding-top: 0 !important;
    }

    .v-btn__content {
        height: 100%
    }

    .v-list__tile__content {
        padding-left: 10px;
    }

    .sport-btn {
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        -webkit-transition: all .3s ease-in-out;
        transition: all .3s ease-in-out;
        background-color: #2b2b2b;
        text-shadow: 1px 1px 2px #0a0a0a;
        color: #fff;
        -webkit-box-shadow: 1px 1px 1px 1px #000;
        box-shadow: 1px 1px 1px 1px #000;
        font-weight: 600;
    }

        .sport-btn:hover, .sport-btn:active {
            background-color: #643e94;
        }

            .sport-btn:hover .v-list__tile__avatar {
                background-color: #2b2b2b;
            }

    .v-list__tile__action, .v-list__tile__avatar {
        min-width: 40px !important;
        border-radius: 50%;
        background-color: #643e94;
    }

    .theme--dark.v-list .v-list__group__header:hover, .theme--dark.v-list .v-list__tile--highlighted, .theme--dark.v-list .v-list__tile--link:hover {
        background: #643e94;
    }

    a {
        cursor: pointer;
    }

    .v-avatar svg {
        width: 100%;
    }

    .v-list__tile {
        padding: 0 8px;
        font-size: 14px !important;
    }

    .v-avatar {
        padding: 7px;
    }

    .v-list__tile--avatar {
        height: 50px !important;
        padding: 0 8px !important;
    }

    .full-height {
        overflow-x: hidden;
        overflow-y: auto;
        height: 100vh;
    }

        .full-height::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
            background-color: #aaa;
        }

        .full-height::-webkit-scrollbar {
            width: 10px;
            background-color: #d3d3d3;
        }

        .full-height::-webkit-scrollbar-thumb {
            background-color: #440f6e;
            border: 2px solid #440f6e;
        }

    .v-card.v-card--flat.v-sheet.theme--dark.grey.darken-3.full-height {
        background: #0a0a0a !important;
    }

    @media (max-width:960px) {
        .v-btn__content {
            white-space: pre-wrap !important;
            width: 100% !important;
        }

        button.btn-submit.v-btn.theme--dark.green .v-btn__content, button.btn-submit.v-btn.v-btn--disabled.theme--dark.green--text .v-btn__content {
            white-space: nowrap !important;
        }

        .full-height {
            height: 100% !important;
        }
    }

    @media (max-width:480px) {
        .title__name {
            text-align: center;
        }
    }

    .title__name {
        font-size: 16px;
        font-weight: 600;
        padding: 16px;
        color: #fff;
        border: 1px solid gold;
        margin-bottom: 15px;
        background: url('../assets/img/tiny-star.png') no-repeat center left;
        padding-left: 46px;
    }

    .v-card div .borders .sport-btn .v-list__tile--avatar {
        border: 1px solid #fff;
    }

    .v-card div .borders .sport-btn:last-child .v-list__tile--avatar {
        border-top-color: transparent;
    }
</style>